import { render } from "./BookingsOrganizer.vue?vue&type=template&id=65b77c71"
import script from "./BookingsOrganizer.vue?vue&type=script&lang=js"
export * from "./BookingsOrganizer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
